import type { Order, Language } from "../../../../../../../services";

const cellProcessing = (
	item: Order.Model["taxiService"],
	language: Language,
): string => item?.settlement?.[language] ?? "";

export default cellProcessing;
